var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKitsIconForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 15.339844 L 375 15.339844 L 375 359.585938 L 3 359.585938 Z M 3 15.339844 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a29e",
    d: "M 11.789062 359.613281 C 11.480469 359.613281 11.171875 359.589844 10.863281 359.539062 C 8.46875 359.148438 6.578125 357.300781 6.132812 354.914062 C 5.503906 351.519531 0.128906 320.597656 5.679688 281.050781 C 8.835938 258.550781 14.917969 237.25 23.765625 217.738281 C 34.71875 193.578125 49.976562 172.054688 69.109375 153.777344 C 111.644531 113.136719 161.121094 99.550781 196.847656 95.53125 L 196.847656 21.546875 C 196.847656 19.25 198.214844 17.175781 200.320312 16.265625 C 202.429688 15.359375 204.875 15.789062 206.542969 17.363281 L 373.042969 174.464844 C 374.191406 175.550781 374.84375 177.0625 374.84375 178.644531 C 374.84375 180.226562 374.191406 181.742188 373.042969 182.824219 L 206.542969 339.933594 C 204.875 341.511719 202.429688 341.941406 200.320312 341.03125 C 198.214844 340.125 196.847656 338.050781 196.847656 335.753906 L 196.847656 247.992188 C 164.355469 248.648438 133.5 256.359375 105.054688 270.941406 C 55.523438 296.339844 28.507812 335.542969 16.816406 356.648438 C 15.789062 358.496094 13.851562 359.613281 11.789062 359.613281 Z M 11.789062 359.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitsIconForward);
export default __webpack_public_path__ + "static/media/kits_icon_forward.29a8abdd49872dbba8282a50fa506d30.svg";
export { ForwardRef as ReactComponent };